export const locale = {
  getLang() {
    if (navigator.languages !== undefined) {
      return navigator.languages[0]
    } else {
      return navigator.language
    }
  },
  getLocaleThousandSeparator() {
    // var n = 1234
    // n = n.toLocaleString(this.getLang()).substring(1, 2)
    // return n

    // FIXME: until proper localization for currency, default to `,`
    return ','
  },
  getDecimalSeparator() {
    // var n = 1.1
    // n = n.toLocaleString(this.getLang()).substring(1, 2)
    // return n

    // FIXME: until proper localization for currency, default to `.`
    return '.'
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/locale.js